import {
	HubConnectionBuilder,
	HttpTransportType,
	LogLevel,
} from "@microsoft/signalr";
import { API_BASE_URL } from "../api/apiServiceFetch";

export const ADMIN_REALTIME_BROWSER_EVENT = "admin:realtime";

const ADMIN_TOKEN_KEY = "jdAdminToken";
const LEGACY_TOKEN_KEY = "token";

let connection = null;
let startPromise = null;

const getAccessToken = () =>
	localStorage.getItem(ADMIN_TOKEN_KEY) || localStorage.getItem(LEGACY_TOKEN_KEY);

const resolveHubUrl = () => {
	const apiRoot = API_BASE_URL.replace(/\/api$/i, "");
	return `${apiRoot}/hubs/app`;
};

const emitRealtime = (payload) => {
	if (typeof window === "undefined") return;

	window.dispatchEvent(
		new CustomEvent(ADMIN_REALTIME_BROWSER_EVENT, {
			detail: payload ?? {},
		}),
	);
};

const ensureConnection = () => {
	if (connection) return connection;

	connection = new HubConnectionBuilder()
		.withUrl(resolveHubUrl(), {
			withCredentials: true,
			transport:
				HttpTransportType.WebSockets |
				HttpTransportType.ServerSentEvents |
				HttpTransportType.LongPolling,
			accessTokenFactory: () => getAccessToken() || "",
		})
		.withAutomaticReconnect([0, 1500, 3000, 6000, 12000])
		.configureLogging(LogLevel.Warning)
		.build();

	connection.on("AdminRealtimeEvent", (payload) => {
		emitRealtime(payload);
	});

	connection.onreconnected(() => {
		emitRealtime({ type: "reconnected", atUtc: new Date().toISOString() });
	});

	connection.onclose(() => {
		startPromise = null;
	});

	return connection;
};

export const startAdminRealtime = async () => {
	const token = getAccessToken();
	if (!token) return null;

	const conn = ensureConnection();
	if (conn.state === "Connected" || conn.state === "Connecting") return conn;

	if (startPromise) return startPromise;

	startPromise = conn
		.start()
		.then(() => conn)
		.catch((error) => {
			console.error("SignalR start failed:", error);
			startPromise = null;
			return null;
		});

	return startPromise;
};

export const stopAdminRealtime = async () => {
	if (!connection) return;

	try {
		await connection.stop();
	} catch (error) {
		console.error("SignalR stop failed:", error);
	} finally {
		startPromise = null;
		connection = null;
	}
};
